export enum SearchActions {
  NEXT_BATCH = '[SearchActions] NEXT_BATCH',
  NEXT_BATCH_ERROR = '[SearchActions] NEXT_BATCH_ERROR',
  NEXT_BATCH_SUCCESS = '[SearchActions] NEXT_BATCH_SUCCESS',
  RESET = 'SEARCH_RESET',
  SEARCH = '[SearchActions] SEARCH',
  SEARCH_ERROR = '[SearchActions] SEARCH_ERROR',
  SEARCH_SUCCESS = '[SearchActions] SEARCH_SUCCESS',
  SET_QUERY_STRING = '[SearchActions] SET_QUERY_STRING',
  SET_SORT_ORDER = '[SearchActions] SET_SORT_ORDER',
  RESULT_FIRST_INTERACTION = '[SearchActions] RESULT_FIRST_INTERACTION',
  PREVIEW_SEARCH_HIT = '[SearchActions] PREVIEW_SEARCH_HIT',
  CLOSE_WELCOME = '[SearchActions] CLOSE_WELCOME',
  SET_THUMBNAIL_SIZE = '[SearchActions] SET_THUMBNAIL_SIZE',
}
